import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Segment } from 'semantic-ui-react'
import { Button, Icon, Modal, List } from 'semantic-ui-react'
import GConf from '../AssetsM/generalConf';
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'

function NavBar(props) {

    const [activeIndex, setActiveIndex] = useState(0)
    const [openD, setOpenD] = useState(false)

    let compteData = JSON.parse(localStorage.getItem(`PID`));
    const compteAuth = compteData; 

    const MainLink = (props) => {
         
        return (<>
        {compteAuth[props.link.toUpperCase()] == 'true' ? 
            <NavLink exact="true" className={({ isActive  }) => isActive ? "p-2 abyedh-list-a" : "p-2 abyedh-list"} to={props.link}><i className={`icons-a bi bi-${props.icon}`}></i> {props.name}  <span className="d-none d-lg-inline"></span></NavLink>
        : <></> }
        </>)
    }
    const ResponsiveLink = (props) => {
        return (<>
            <NavLink exact="true" className={({ isActive  }) => isActive ? "p-2 abyedh-list-a" : "p-2 abyedh-list"} to={props.link}><i className={`icons-a bi bi-${props.icon}`}></i> {props.name}  <span className="d-none d-lg-inline"></span></NavLink>
        </>)
    }
    const OpenBottomSheetFunction = (genre) => {
        setActiveIndex(genre)
        setOpenD(!openD)
    }

    const LogOut = () =>{
        //localStorage.clear();
        localStorage.removeItem(`PID`);
        window.location.href = "/login";
    }
    const Refresh = () =>{
        window.location.reload();
    }
    const MainSmallLink = (props) => {
            return (<>
                <div className='p-1 text-center ' >
                <NavLink exact="true" className={({ isActive  }) => isActive ? "p-2 text-system" : "p-2 text-secondary"} to={props.link}>
                    <i className={`bi bi-${props.icon}`} style={{fontSize:'25px'}}></i>
                    <h5 className='mt-0 mb-0'>{props.name}</h5> 
                </NavLink>
                </div>
                
            </>)
        }
    const MainCardNav = () => {
        return(<>
         <div className='row'>
            {GConf.NavsData.map((links) => 
                <div className="col-4" key={links.id}><MainSmallLink name={links.name} link={links.link} icon={links.icon} /></div>
            )}   
        </div>
        </>)
    }
    const SmallCardNav = () => {
        return(<>
            <div className='row'>
                 
                <div className='col-4 col-lg align-self-center text-center border-end '>
                    <NavLink to='/S/notif' exact="true" className={({ isActive }) => isActive ? "ps-1 pe-1 abyedh-list-a-s" : "ps-1 pe-1 abyedh-list"}><i className="bi bi-bell bi-md "></i></NavLink>
                    <h6>Notification</h6>
                </div> 
                <div className='col-4 col-lg align-self-center text-center'>
                    <NavLink onClick={LogOut} to='#' exact="true" className='ps-1 pe-1'><span className="bi bi-box-arrow-left bi-md"></span></NavLink>
                    <h6>deconextion</h6>
                </div>   
            </div>
        </>)
    }
    return (<>
        <div className="fixed-top">
            <div className="rounded-0 p-3 bg-white border-bottom blur-bckg-st">
                <div className="row">
                    <div className="col-3 col-md-2 align-self-center text-left">
                        <img src="https://cdn.abyedh.com/Images/main-logo.png" alt="." className="p-0" width="40px" height="30px"/>
                    </div>
                    <div className="col-5 col-md-8 align-self-center text-left navsha">
                       <div className="text-left d-none d-lg-block"> 
                            {GConf.NavsData.map((links) => 
                                <MainLink key={links.id} name={links.name} link={links.link} icon={links.icon} />
                            )}
                        </div>
                        <Button className="d-lg-none rounded-pill bg-system-btn" onClick={() => OpenBottomSheetFunction('main')}> <Icon name='list alternate outline' /> Menu</Button>
                         
                       
                    </div>
                    <div className="col-4 col-md-2 align-self-center text-end">
                        <div className="dropdown d-none">
                            <NavLink onClick={Refresh} to='#' exact="true" className='ps-1 pe-1'><span className="bi bi-arrow-clockwise fa-lg text-danger"></span></NavLink>
                            <NavLink to='nt' exact="true" className={({ isActive }) => isActive ? "ps-1 pe-1 abyedh-list-a-s" : "ps-1 pe-1 abyedh-list"}><i className="bi bi-bell fa-lg "></i></NavLink>
                            <NavLink to='up' exact="true" className={({ isActive }) => isActive ? "ps-1 pe-1 abyedh-list-a-s" : "ps-1 pe-1 abyedh-list"}><i className="bi bi-cloud-arrow-down fa-lg "></i></NavLink>
                            {/* <NavLink to='msg' exact="true" className={({ isActive }) => isActive ? "ps-1 pe-1 abyedh-list-a-s" : "ps-1 pe-1 abyedh-list"}><i className="bi bi-envelope fa-lg"></i></NavLink> */}
                            <NavLink onClick={LogOut} to='#' exact="true" className='ps-1 pe-1'><span className="bi bi-box-arrow-left fa-lg"></span></NavLink>
                        </div>
                        <NavLink onClick={Refresh} to='#' exact="true" className='ps-1 pe-3 mt-3'><span className="bi bi-arrow-clockwise fa-lg text-danger"></span></NavLink>
                        <Button className="d-lg-none border-div  bg-system-btn" size='tiny' icon onClick={() => OpenBottomSheetFunction('small')}> <Icon name='user' /></Button>
                    </div>
                </div>
            </div>
        </div>
        <BottomSheet expandOnContentDrag open={openD}  onDismiss={() => setOpenD(!openD)}  >
            <div className='card-body'>
                
                { activeIndex =='main' ?   <MainCardNav /> : <></> }  
                { activeIndex == 'small' ?  <SmallCardNav /> : <></> }
                
                </div>
        </BottomSheet>
    </>);
}

export default NavBar;
